import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { Client } from '../models/client.model';
import { environment } from '../../environments/environment';

export interface CreateClientDto {
  name: string;
  description?: string;
  isActive?: boolean;
  serviceGroupId?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private apiUrl = `${environment.apiUrl}/Client`;

  constructor(private http: HttpClient) { }

  getAllClients(): Observable<Client[]> {
    return this.http.get<Client[]>(this.apiUrl).pipe(retry(2));
  }

  addClient(client: Client): Observable<Client> {
    const createDto: CreateClientDto = {
      name: client.name,
      description: client.description,
      isActive: client.isActive,
      serviceGroupId: client.serviceGroupId || null
    };
    return this.http.post<Client>(this.apiUrl, createDto);
  }

  updateClient(id: string, client: Client): Observable<Client> {
    return this.http.put<Client>(`${this.apiUrl}/${id}`, client);
  }
}


